export default {
  updateLayout(context, item){
    context.commit('updateLayout', item);
  }
};
